const doc = [({"en":({"js":({"components":({"subscriptions":({"start_unicorn_user_trial_button":({"your_unicorn_trial_has_been_started":"Your Unicorn trial has been started."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;